import { ProductKeyTypes } from "@/libraries/wpl/foundations/src";
import {
    TeamTourBannerAlert,
    TeamTourBannerProps
} from "@/patterns/wpl/ad-banner/src/team-tour-banner";

export const TeamTourJapanBanner = (props: {
    dataProductKey: ProductKeyTypes;
}) => {
    const bannerMessages: TeamTourBannerProps = {
        identifier: "TeamTourJapanBanner",
        text: "Atlassian TEAM TOUR Tokyo 2024 のセッション動画を期間限定で公開します",
        mobileHeaderText: "TEAM TOUR: TOKYO",
        linkText: "詳細・お申し込みはこちら",
        linkUrl:
            "https://events.atlassian.com/teamtour_tokyo?ref=self-referral_butter-banner&utm_medium=self-referral&utm_source=butter-banner&utm_campaign=V:butter-banner*O:japan*H:fy25q1*I:ttt24",
        dataEventProps: {
            "data-product-key": props.dataProductKey,
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "詳細・お申し込みはこちら"
        },
        lockupImageSrc:
            "https://wac-cdn.atlassian.com/misc-assets/webp-images/CSD-11737 TeamTour_Tokyo_lockup.svg"
    };

    return <TeamTourBannerAlert {...bannerMessages} />;
};
